<template>
  <div>
    <h2 class="page-title">TOTAL: {{ formatPrice(total) }}</h2>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="reversedPayments"
          class="elevation-1"
          :search="search"
          :footer-props="{
            'items-per-page-options': [50, 100, 150, -1]
          }"
          :items-per-page="50"
          no-data-text="No se han encontrado resultados !"
        >
          <template v-slot:[`item.number`]="{ item }">
            {{
              item.invoiceRequest
                ? item.legal_number || item.number
                : item.number
            }}
          </template>
          <template v-slot:[`item.externalPaymentId`]="{ item }">
            <div
              :style="{ cursor: item.externalPaymentId && 'pointer' }"
              @click="copyId(item.externalPaymentId)"
              class="text-truncate"
              :title="item.externalPaymentId"
            >
              {{ item.externalPaymentId || "" }}
            </div>
          </template>
          <template v-slot:[`item.payment_on`]="{ item }">
            <span class="day-format">{{ dayFormatLL(item.payment_on) }}</span>
            {{ formatTime(item.payment_on) }}
          </template>
          <template v-slot:[`item.payment_method`]="{ item }">
            <span>{{ displayPaymentMethod(item.payment_method) }}</span>
          </template>
          <template v-slot:[`item.amount_paid_by_user`]="{ item }">
            {{ formatPrice(item.amount_paid_by_user) }}
          </template>
          <template v-slot:[`item.invoiceRequest`]="{ item }">
            {{ item.invoiceRequest === true ? "Factura" : "Ticket" }}
          </template>
          <template v-slot:[`item.receipt_is_sent`]="{ item }">
            {{ item.receipt_is_sent === true ? "Si" : "No" }}
          </template>
          <template v-slot:[`item.editAction`]="{ item }">
            <font-awesome-icon
              style="cursor: pointer;"
              @click="openPaymentDetailDialog(item)"
              icon="eye"
              :style="{ color: 'black', fontSize: 20 }"
            />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <PaymentDetailDialog
      ref="paymentDetailDialog"
      :ticketPrinter="ticketPrinter"
    ></PaymentDetailDialog>
  </div>
</template>

<script>
import PaymentDetailDialog from "./PaymentDetailDialog";
import { PaymentsHistoryTableHeader } from "@/utils/tableHeaderconstants";
let xlsx = require("json-as-xlsx");

export default {
  name: "Payments-history",
  components: {
    PaymentDetailDialog
  },
  props: {
    ticketPrinter: {
      type: Object
    },
    payments: Array,
    default: null,
    search: String
  },
  data() {
    return {
      headers: [...PaymentsHistoryTableHeader]
    };
  },
  computed: {
    reversedPayments() {
      return [...this.payments].reverse();
    },
    total() {
      return this.payments.reduce((a, b) => {
        return Number(a) + Number(b.amount_paid_by_user);
      }, 0);
    }
  },
  methods: {
    exportToExcel(excelName) {
      let data = [
        {
          sheet: "Payments",
          columns: [
            {
              label: "NÚMERO",
              value: row =>
                row.invoiceRequest ? row.legal_number || row.number : row.number
            },
            {
              label: "ID DE PAGO EXTERNO",
              value: row => row.externalPaymentId || ""
            },
            {
              label: "FECHA DE PAGO",
              value: row =>
                this.dayFormatLL(row.payment_on) +
                " " +
                this.formatTime(row.payment_on)
            },
            {
              label: "MESA",
              value: row => row.tableQR
            },
            {
              label: "METÓDO DE PAGO",
              value: row => this.displayPaymentMethod(row.payment_method)
            },
            {
              label: "FACTURA/TICKET",
              value: row => (row.invoiceRequest === true ? "Factura" : "Ticket")
            },
            {
              label: "FACTURA/TICKET ENVIADO",
              value: row => (row.receipt_is_sent === true ? "Si" : "No")
            },
            {
              label: "BASE IMPONIBLE",
              value: row =>
                this.formatPriceWithoutCurrency(
                  this.getTaxBase(row.amount_paid_by_user)
                )
            },
            {
              label: "IVA (10%)",
              value: row =>
                this.formatPriceWithoutCurrency(
                  this.getIVA(row.amount_paid_by_user)
                )
            },
            {
              label: "TOTAL",
              value: row =>
                this.formatPriceWithoutCurrency(row.amount_paid_by_user)
            }
          ],
          content: this.payments
        }
      ];
      let settings = {
        fileName: excelName, // Name of the spreadsheet
        extraLength: 3, // A bigger number means that columns will be wider
        writeOptions: {} // Style options from https://github.com/SheetJS/sheetjs#writing-options
      };

      xlsx(data, settings); // Will download the excel file
    },
    copyId(id) {
      if (!id) return;
      navigator.clipboard.writeText(id);
      this.showSuccessMessage("Copied");
    },
    displayPaymentMethod(payment_method) {
      if (payment_method === "credit_card") {
        return "Tarjeta de crédito";
      }

      if (payment_method === "cash") {
        return "Efectivo";
      }

      if (payment_method === "applepay") {
        return "Apple Pay";
      }

      if (payment_method === "datafono") {
        return "Tarjeta de crédito (Datáfono)";
      }

      if (payment_method === "googlepay") {
        return "Google Pay";
      }

      if (payment_method === "bizum") {
        return "Bizum";
      }
    },
    openPaymentDetailDialog(data) {
      this.$refs.paymentDetailDialog.open(data);
    }
  }
};
</script>

<style scoped lang="scss">
.day-format {
  font-size: 10px;
}

.table-scroll {
  max-width: 100%;
  overflow-x: auto;
}

.admin-orders table thead th {
  width: 180px;
}

@media screen and (max-width: 873px) {
  .admin-orders table thead th {
    width: 130px;
  }
}

@media only screen and (min-width: 393px) and (max-width: 767px) {
  .admin-orders table thead th {
    width: 162px;
  }
}
</style>
